<app-info-popper
  *ngIf="shouldShowTablebaseInfo"
  [icon]="'warning'"
  [popperAppendTo]="popperAppendTo"
>
  <p>
    Your results are filtered by <b>{{ tablebaseTitle }}</b>
  </p>
</app-info-popper>
